"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = exports.rowsPerPageOptions = exports.partyTypeOptions = exports.columns = void 0;
var statusOptions = [
    { key: "all", label: "All" },
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
var partyTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "Tenant", label: "Tenant" },
    { key: "Landlord", label: "Landlord" },
];
exports.partyTypeOptions = partyTypeOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var columns = [
    { name: "NAME", uid: "name" },
    { name: "REG. NUMBER", uid: "registrationNumber" },
    { name: "TENANT CODE", uid: "tenantCode" },
    { name: "PARTY TYPE", uid: "partyType" },
    { name: "AREA NUMBER", uid: "areaNumber" },
    { name: "CONTACT", uid: "contactDetails" },
    { name: "STATUS", uid: "status" },
    { name: "CREATED", uid: "createdAt" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
